export default {"id":"239f98cd","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}